import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../utils/scale-size';
import { Focusable } from './navigation';

const StyledButton = styled(Focusable)`
  min-width: ${scaleSize(140)}px;
  height: ${scaleSize(80)}px;
  line-height: ${scaleSize(80)}px;
  font-size: ${scaleSize(32)}px;
  padding: 0 ${scaleSize(30)}px;
  margin-right: ${scaleSize(20)}px;
  font-family: RobotoCondensedBold, sans-serif;
  font-weight: 700;
  text-align: center;
  border-radius: 8px;
  border: solid 2px ${({ theme }) => theme.buttonBorderColor};
  color: ${({ isActive, disabled, theme }) => {
    if (disabled) return theme.secondaryTextColor;
    if (isActive) return theme.activeColor;
    return theme.mainTextColor;
  }};
  display: inline-block;

  path {
    fill: ${({ isActive, theme }) => (isActive ? theme.activeColor : theme.iconDefaultColor)};
    stroke: ${({ isActive, theme }) => (isActive ? theme.activeColor : theme.iconDefaultColor)};
  }

  svg {
    margin-right: ${scaleSize(10)}px;
  }

  &:focus {
    color: ${({ theme }) => theme.activeColorText};
    background: ${({ theme }) => theme.activeColor};
    border-color: ${({ theme }) => theme.activeColor};

    path {
      fill: ${({ theme }) => theme.activeColorText};
      stroke: ${({ theme }) => theme.activeColorText};
    }
  }
`;

class Button extends Component {
  render() {
    const {
      children,
      onFocus,
      onEnter,
      isActive,
      focusOnMouseEnter,
      id,
      payload,
      disabled,
      ...rest
    } = this.props;

    return (
      <StyledButton
        onFocus={onFocus}
        onEnter={onEnter}
        isActive={isActive}
        focusOnMouseEnter={focusOnMouseEnter}
        id={id}
        payload={payload}
        disabled={disabled}
        {...rest}
      >
        {children}
      </StyledButton>
    );
  }
}

export default Button;
